import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

// Custom hook to access auth context data
export const useAuth = () => useContext(AuthContext);
